import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  sectionText: {
    fontSize: '14px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px !important',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    width: '100%',
  },
  widthTextArea: {
    width: '100%',
  },
  dialog: {
    marginTop: theme.spacing(-5),
    marginLeft: theme.spacing(-5),
    marginRight: theme.spacing(-5),
    marginBottom: theme.spacing(-3),
  },
  sectionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    width: '100%',
    boxSizing: 'border-box',
  },
}))
